<form [formGroup]="form" *ngIf="cultures$ | async as cultures">
  <mat-form-field>
    <mat-select placeholder="Choose culture" formControlName="culture">
      <mat-option *ngFor="let culture of cultures" [value]="culture">
        {{culture.Culture}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
